module.exports = __webpack_public_path__ + "static/media/lockIcon.89444c5b.svg";